import { HandballIncidentId } from '@collector/sportsapi-client-legacy'
import { PopupBuilder } from '@mobile/views/Relation/Shared/Popup/builder/PopupBuilder'

export const RedCardPopup = new PopupBuilder('RedCard', {
  incident_id: HandballIncidentId.RedCard,
})
  .withTeamSelection()
  .omitDetailsView()
  .build()
